import VAvatar from './VAvatar';
export { VAvatar };
export default VAvatar;
//# sourceMappingURL=index.js.map